
export default () => {
    return localStorage.getItem('flyBusToken')
}